import {
    createIcons,
    ClipboardList,
    Terminal,
    ArrowLeft,
    UserCheck,
    Globe,
    Wrench,
    Puzzle,
    User,
    Users,
    Search,
    FileText,
    Code,
    CheckCircle,
    TrendingUp,
    Mail,
    AlertCircle,
    ChevronDown,
    ChevronRight,
    ArrowRight,
    Send,
    Code2,
    Check,
    CheckCircle2,
    Command,
    Gauge,
    Activity,
    Database,
    Workflow,
    Layers,
    LayoutTemplate,
    ShieldCheck,
    Scale,
    Cpu,
    BrickWall,
    MonitorSmartphone,
    Network,
    HelpCircle,
    Shield,
    ShieldAlert,
    GitCommit,
    Clock,
    Zap,
    Rocket,
    X,
    ExternalLink,
    GitBranch,
    Menu
} from 'lucide';

export function initIcons() {
    createIcons({
        icons: {
            ClipboardList,
            Terminal,
            ArrowLeft,
            UserCheck,
            Globe,
            Wrench,
            Puzzle,
            User,
            Users,
            Search,
            FileText,
            Code,
            Check,
            CheckCircle,
            TrendingUp,
            Mail,
            AlertCircle,
            ChevronDown,
            ChevronRight,
            ArrowRight,
            Send,
            Code2,
            CheckCircle2,
            Command,
            Gauge,
            Activity,
            Database,
            Workflow,
            Layers,
            LayoutTemplate,
            ShieldCheck,
            Scale,
            Cpu,
            BrickWall,
            MonitorSmartphone,
            Network,
            HelpCircle,
            Shield,
            ShieldAlert,
            GitCommit,
            Clock,
            Zap,
            Rocket,
            X,
            ExternalLink,
            GitBranch,
            Menu
        }
    });
}